  
export default async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc);

  // Taille finale en pixels pour 5 x 5 cm à 300 dpi
  const finalSize = Math.round(5 * 300 / 2.54); // ≈ 591 px

  const canvas = document.createElement('canvas');
  canvas.width = finalSize;
  canvas.height = finalSize;
  const ctx = canvas.getContext('2d');

  // Dessiner le crop en redimensionnant vers la taille finale
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    finalSize,
    finalSize
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      const fileUrl = URL.createObjectURL(blob);
      resolve(fileUrl);
    }, 'image/jpeg', 0.9);
  });
}

  export const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', () => resolve(image));
      image.addEventListener('error', (error) => reject(error));
      image.setAttribute('crossOrigin', 'anonymous'); // éviter les soucis CORS
      image.src = url;
    });